export default "__VITE_ASSET__DZ5iR_ib__"